import { createStyles, MarginProps } from "../theme";
import { Col } from "./col";

type Props = MarginProps;

export function Divider(props: Props) {
  return <Col {...props} style={$.container} />;
}

const $ = createStyles({
  container: {
    backgroundColor: "overlay",
    height: 0.5,
  },
});
